import { createContext } from "react";

import { Auth } from "../types";

export const AuthContext = createContext<Auth | null>(null);
export const KlsContext = createContext<Auth["kls"] | null>(null);
export const SetAuthItemContext = createContext<Auth["setAuthItem"] | null>(
  null,
);
export const MultiSetAuthItemContext = createContext<
  Auth["multiSetAuthItem"] | null
>(null);
export const GetAuthItemContext = createContext<Auth["getAuthItem"] | null>(
  null,
);
export const RemoveAuthItemContext = createContext<
  Auth["removeAuthItem"] | null
>(null);
export const GetAccessTokenContext = createContext<
  Auth["getAccessToken"] | null
>(null);
export const IsAuthenticatedContext = createContext<
  Auth["isAuthenticated"] | null
>(null);
export const HasTwoFactorTokenContext = createContext<
  Auth["hasTwoFactorToken"] | null
>(null);
export const LogoutContext = createContext<Auth["logout"] | null>(null);
export const AuthFetchContext = createContext<Auth["authFetch"] | null>(null);
export const SuperAuthFetchContext = createContext<
  Auth["superAuthFetch"] | null
>(null);
export const LoginContext = createContext<Auth["login"] | null>(null);
export const SendCodeContext = createContext<Auth["sendCode"] | null>(null);
export const LoginWithCodeContext = createContext<Auth["loginWithCode"] | null>(
  null,
);
export const InterceptorsContext = createContext<Auth["interceptors"] | null>(
  null,
);
export const AccessTokenCookieContext = createContext<
  Auth["accessTokenCookie"] | null
>(null);
